'use strict';

var $ = require('jquery');

module.exports = class {
  constructor({
    imgSrc = 'http://www.thesoundarchive.com/images/Tiles/austin-powers.png',
    imgClass = 'peeker',
    soundSrc
  }) {
    this.img = new Image();
    this.img.src = imgSrc;
    this.$img = $(this.img);
    this.$img.addClass(imgClass);
    $('body').append(this.$img);

    if (typeof soundSrc !== 'undefined') {
      this.sound = new Audio(soundSrc);
      this.sound.loop = false;
    }

    this.$img.on('webkitAnimationEnd oanimationend oAnimationEnd MSAnimationEnd animationend', () => this.$img.removeClass('animate-fun'));
  }

  play() {
    if (typeof this.sound !== 'undefined') this.sound.play();
    this.$img.addClass('animate-fun');

  }

  destroy() {
    $('body').remove(this.img);
  }
};
